
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 2118 1921.8"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"escena_x5F_path"}},[_c('path',{attrs:{"id":"escenario_x5F_1_x5F_path","d":"M2114.7 609.9L1057.4.3 0 610.8l.1 697.6 1057.4 610.5 1057.2-610.5V609.9z","opacity":".15","fill":"#fff"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_01","fill":"rgba(10,10,10,0.2)","d":"M1541.2 746.8h317.9v327.3h-317.9z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_02","fill":"rgba(10,10,10,0.2)","d":"M369 1121.5h389v203.2H369z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_03","fill":"rgba(10,10,10,0.2)","d":"M323.2 837.3h365v231.1h-365z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_04","fill":"rgba(10,10,10,0.2)","d":"M1160.2 937.4h331.6v343.3h-331.6z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_05","fill":"rgba(10,10,10,0.2)","d":"M1167.9 621h350.3v226.6h-350.3z"}})])])
          )
        }
      }
    